module.exports = __webpack_public_path__ + "static/cashback-banner-1-76672c6e546d04b452fc1be50db97910.png";